import { withProps } from 'recompose';
import { omit, pick } from 'lodash';
import ImageQuestion from './ImageQuestion';
import ImageRadioGroupField from './ImageRadioGroupField';

export default withProps(ownProps => ({
  inputField: ImageRadioGroupField,
  handleSubmit: ({ comments, value }) =>
    ownProps.onAnswer({ comments, ...value }),
  initialValues: {
    value: omit(ownProps.answer, 'comments'),
    ...pick(ownProps.answer, 'comments'),
  },
}))(ImageQuestion);
